<template>
  <div class="d-flex align-items-center mt-4 flex-wrap">
    <h1 :class="edit && 'w-100'">
      {{ title }} für
      <div class="d-inline-flex align-items-center" :style="edit && 'font-size: 1rem;width: 100%;margin-top: .25rem;'">
        <span v-if="!edit" class="text-break">
          {{ menu?.attributes?.name }}
        </span>
        <base-form-input
          v-if="edit"
          :errors="menu?.errors ? menu.errors?.name : null"
          :required="true"
          :max="max"
          :value="menu?.attributes ? menu.attributes?.name : ''"
          attribute="contact"
          label="Name der Karte (Nur innerhalb des Gastroportals - wird nicht gedruckt)"
          name="menuname"
          @update:data="$emit('update:data', { name: $event.target.value })"
        ></base-form-input>
        <button
          v-if="edit"
          type="button"
          class="d-inline-block btn text-muted hover:text-secondary bg-white ms-2 mb-3"
          style="border: 1px solid #ced4da; height: 3.625rem; width: 3.625rem"
          @click="toggleEdit()"
        >
          <base-icon-save></base-icon-save>
        </button>
        <button v-else type="button" class="btn btn btn-secondary text-white ms-2 text-nowrap" @click="toggleEdit()">
          Namen der Karte ändern
        </button>
      </div>
    </h1>
  </div>
  <div :style="edit && 'margin-top:-.5rem'">
    <slot></slot>
  </div>
</template>

<script>
import { ref } from 'vue';
export default {
  props: {
    menu: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: null,
    },
  },
  emits: ['update:data'],
  setup() {
    const edit = ref(false);
    const toggleEdit = () => {
      edit.value = !edit.value;
      if (edit.value) {
        setTimeout(() => {
          const input = document.getElementById('menuname');
          input.focus();
        }, 100);
      }
    };
    return { edit, toggleEdit };
  },
};
</script>

<style lang="scss" scoped></style>
